/**
 * Web Style Import
 *
 */

import './style/dnb-form-status.scss'
